import React from 'react'

import Xray from "../images/X-RAY icon.jpg"
import usg from "../images/USG.jpg";
import Ctscan from "../images/CT-SCAN.jpg";
import Mri from "../images/MRI ICON.jpg";
import opgnew from "../images/OPG.jpg";

function Radiology() {
    return (
        <div>
           
            <div className="album py-2">
                <div className="container">
                    <div className="row">

                        <div className="col-md-3 mt-3">
                        <a href='xray'>
                            <div class="card">
                                <img src={Xray} className="card-img-top mb-3" alt="xray" />
                                <div className="card-body">
                                    <center>
                                        <h5 style={{ color: "darkblue" }} className="card-title mb-1">X-Ray</h5>
                                        <p style={{ color: "darkBlue" }} className="card-text">Learn More <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "darkBlue" }} width="13" height="13" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                            <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                        </svg></p>
                                    </center>

                                </div>
                            </div>
                            </a>
                        </div>
                        <div className="col-md-3 mt-3">
                            <a  href='usg'>
                                <div class="card">
                                    <img src={usg} className="card-img-top mb-3" alt="usg"/>
                                    <div className="card-body">
                                        <center>
                                            <h5 style={{ color: "darkBlue" }} className="card-title mb-0">USG</h5>
                                            <p style={{ color: "darkBlue" }} className="card-text">Learn More <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "darkBlue" }} width="13" height="13" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                                <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                            </svg></p>
                                        </center>

                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-3 mt-3">
                            <a href='ct-scan'>
                                <div class="card">

                                    <img src={Ctscan} className="card-img-top mb-3" alt="Ctscan" />
                                    <div className="card-body">
                                        <center>
                                            <h5 style={{ color: "darkBlue" }} className="card-title mb-0">CT-Scan</h5>
                                            <p style={{ color: "darkBlue" }} className="card-text">Learn More <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "darkBlue" }} width="13" height="13" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                                <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                            </svg></p>
                                        </center>
                                    </div>
                                </div>
                            </a>
                        </div>


                        <div className="col-md-3 mt-3">
                            <a href='mri' >
                                <div class="card">
                                    <img src={Mri} className="card-img-top mb-3" alt="mri" />
                                    <div className="card-body">
                                        <center>
                                            <h5 style={{ color: "darkBlue" }} className="card-title mb-0">MRI</h5>
                                            <p style={{ color: "darkBlue" }} className="card-text">Learn More <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "darkBlue" }} width="13" height="13" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                                <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                            </svg></p>
                                        </center>
                                    </div>
                                </div>
                            </a>
                        </div>


                        <div className="col-md-3 mt-3">
                            <a href='opg'>
                                <div class="card">
                                    <img src={opgnew} className="card-img-top mb-3" alt="opg" />
                                    <div className="card-body">
                                        <center>
                                            <h5 style={{ color: "darkBlue" }} className="card-title mb-0">OPG</h5>
                                            <p style={{ color: "darkBlue" }} className="card-text">Learn More <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "darkBlue" }} width="13" height="13" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                                <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                            </svg></p>
                                        </center>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>

                </div>
            </div>
          
         
        </div>
    )
}

export default Radiology